import React from "react";
import { useGlobalData } from "../../../../provider/GlobalDataProvider";

export default function withGlobalData(Component = null) {
  return (props) => {
    const globalData = useGlobalData();
    return <Component globalData={globalData} {...props} />;
  };
}
